import React, { useState, useEffect } from 'react';
import { QRCodeCanvas } from 'qrcode.react';

const GOLD='#F5A623',DARK='#2C2C2A',NAVY='#1E3A5F',GREEN='#22C55E',RED='#EF4444';
const s = {
  btn:{padding:'9px 20px',borderRadius:'10px',fontSize:'13px',fontWeight:700,cursor:'pointer',border:'none',fontFamily:"'Syne',sans-serif"},
  card:{background:'#fff',border:'0.5px solid #D3D1C7',borderRadius:'14px',padding:'16px 20px',marginBottom:'10px'},
};

const api = async (endpoint, options={}) => {
  const token = localStorage.getItem('token');
  const res = await fetch('/api' + endpoint, {
    headers:{'Content-Type':'application/json',...(token?{Authorization:'Bearer '+token}:{})},
    ...options
  });
  return res.json();
};

function NFCSection({ user }) {
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editTag, setEditTag] = useState(null);
  const [vehicles, setVehicles] = useState([]);
  const [destForm, setDestForm] = useState({ destination: 'account', vehicle_id: '' });
  const [msg, setMsg] = useState('');

  useEffect(() => {
    if (!user) return;
    loadTags();
    api('/vehicles').then(d => d.vehicles && setVehicles(d.vehicles));
  }, [user]);

  const loadTags = async () => {
    setLoading(true);
    const data = await fetch('/api/public/nfc/user/' + user.id, {
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
    }).then(r => r.json());
    setTags(data.tags || []);
    setLoading(false);
  };

  const saveDestination = async () => {
    const data = await fetch('/api/public/nfc/user/update', {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + localStorage.getItem('token') },
      body: JSON.stringify({ tag_id: editTag.id, destination: destForm.destination, vehicle_id: destForm.vehicle_id || null }),
    }).then(r => r.json());
    if (data.message) {
      setMsg('✓ Destinație actualizată.');
      setEditTag(null);
      loadTags();
      setTimeout(() => setMsg(''), 3000);
    } else {
      setMsg(data.error || 'Eroare');
    }
  };

  const destLabel = (tag) => {
    if (tag.destination === 'setup' || !tag.user_id) return '⚙️ Neactivat';
    if (tag.destination === 'account') return '📱 Cont principal';
    if (tag.destination === 'vehicle') return `🚗 ${tag.vehicle_plate || tag.vehicle_brand || 'Mașină'}`;
    return tag.destination;
  };

  if (loading) return <div style={{textAlign:'center',padding:'20px',color:'#888',fontSize:'13px'}}>Se încarcă tag-urile NFC...</div>;
  if (tags.length === 0) return (
    <div style={{...s.card,textAlign:'center',padding:'28px'}}>
      <div style={{fontSize:'40px',marginBottom:'10px'}}>🏷️</div>
      <div style={{fontWeight:700,marginBottom:'6px'}}>Nu ai tag-uri NFC asociate</div>
      <div style={{fontSize:'12px',color:'#888',lineHeight:1.6}}>Tag-urile NFC se activează scanând un tag și logându-te în cont, sau prin legătura cu un link NFC trimis de Premium Support Iași.</div>
    </div>
  );

  return (
    <div>
      {msg && <div style={{background:msg.includes('✓')?'#DCFCE7':'#FEE2E2',borderRadius:'8px',padding:'9px 12px',fontSize:'12px',color:msg.includes('✓')?'#15803D':'#B91C1C',marginBottom:'10px'}}>{msg}</div>}
      {tags.map(tag => (
        <div key={tag.id} style={s.card}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',flexWrap:'wrap',gap:'8px'}}>
            <div>
              <div style={{fontFamily:'monospace',fontSize:'13px',fontWeight:700,color:DARK}}>{tag.token.substring(0,8)}…</div>
              {tag.label && <div style={{fontSize:'11px',color:'#888'}}>{tag.label}</div>}
              <div style={{marginTop:'4px'}}>
                <span style={{background:'#E8EEF5',color:NAVY,padding:'2px 8px',borderRadius:'6px',fontSize:'11px',fontWeight:600}}>{destLabel(tag)}</span>
              </div>
            </div>
            <div style={{display:'flex',flexDirection:'column',alignItems:'flex-end',gap:'4px'}}>
              <div style={{fontSize:'11px',color:'#aaa'}}>
                {tag.last_scanned_at ? `Ultima scanare: ${new Date(tag.last_scanned_at).toLocaleDateString('ro-RO')}` : 'Nescanat încă'}
              </div>
              <div style={{fontSize:'11px',color:'#aaa'}}>{tag.scan_count} scanări</div>
              <button
                onClick={() => { setEditTag(tag); setDestForm({ destination: tag.destination || 'account', vehicle_id: tag.vehicle_id || '' }); }}
                style={{...s.btn,background:'#E8EEF5',color:NAVY,padding:'5px 12px',fontSize:'11px'}}
              >
                ✏️ Schimbă destinația
              </button>
            </div>
          </div>
        </div>
      ))}

      {editTag && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999,padding:'16px'}}>
          <div style={{background:'#fff',borderRadius:'14px',maxWidth:'400px',width:'100%',overflow:'hidden'}}>
            <div style={{background:NAVY,padding:'14px 20px',display:'flex',alignItems:'center',justifyContent:'space-between',color:'#fff'}}>
              <div style={{fontWeight:800,fontSize:'14px'}}>✏️ Schimbă destinația tag-ului</div>
              <button onClick={()=>setEditTag(null)} style={{background:'rgba(255,255,255,.15)',border:'none',borderRadius:'7px',padding:'4px 9px',color:'#fff',cursor:'pointer'}}>✕</button>
            </div>
            <div style={{padding:'20px'}}>
              <div style={{marginBottom:'14px'}}>
                <div style={{fontSize:'10px',fontWeight:700,color:'#888',textTransform:'uppercase',letterSpacing:'.4px',marginBottom:'8px'}}>Destinație</div>
                {[
                  { val: 'account', label: '📱 Cont principal', desc: 'Accesează toate mașinile' },
                  { val: 'vehicle', label: '🚗 Mașină specifică', desc: 'Duce direct la pagina mașinii' },
                ].map(opt => (
                  <div key={opt.val} onClick={() => setDestForm({...destForm, destination: opt.val})}
                    style={{border:`2px solid ${destForm.destination===opt.val?GOLD:'#E5E5E5'}`,borderRadius:'10px',padding:'10px 14px',marginBottom:'8px',cursor:'pointer',background:destForm.destination===opt.val?'#FEF3DC':'#fff'}}>
                    <div style={{fontWeight:700,fontSize:'13px'}}>{opt.label}</div>
                    <div style={{fontSize:'11px',color:'#888'}}>{opt.desc}</div>
                  </div>
                ))}
              </div>
              {destForm.destination === 'vehicle' && vehicles.length > 0 && (
                <div style={{marginBottom:'14px'}}>
                  <div style={{fontSize:'10px',fontWeight:700,color:'#888',textTransform:'uppercase',letterSpacing:'.4px',marginBottom:'6px'}}>Selectează mașina</div>
                  <select value={destForm.vehicle_id} onChange={e=>setDestForm({...destForm,vehicle_id:e.target.value})}
                    style={{background:'#F4F4F4',border:'0.5px solid #D3D1C7',borderRadius:'9px',padding:'9px 13px',fontSize:'13px',width:'100%',fontFamily:"'Syne',sans-serif"}}>
                    <option value="">-- Selectează mașina --</option>
                    {vehicles.map(v => (
                      <option key={v.id} value={v.id}>{v.plate_number || v.vin} — {v.brand} {v.model}</option>
                    ))}
                  </select>
                </div>
              )}
              <button onClick={saveDestination} style={{...s.btn,background:GOLD,color:DARK,width:'100%'}}>Salvează</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default function QRPage({ user }) {
  const [qrData, setQrData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [copied, setCopied] = useState(false);
  const [activeTab, setActiveTab] = useState('qr');

  const currentUser = user || JSON.parse(localStorage.getItem('user') || '{}');

  useEffect(() => { loadQR(); }, []);

  const loadQR = async () => {
    setLoading(true);
    const data = await api('/public/my-token');
    if (data.public_token) setQrData(data);
    setLoading(false);
  };

  const copyLink = () => {
    if (!qrData) return;
    navigator.clipboard.writeText(qrData.public_url);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const downloadQR = () => {
    const canvas = document.getElementById('qr-canvas');
    if (!canvas) return;
    const url = canvas.toDataURL('image/png');
    const a = document.createElement('a');
    a.href = url;
    a.download = 'QR_acces_dosarmasina.png';
    a.click();
  };

  const printCard = () => {
    if (!qrData) return;
    const canvas = document.getElementById('qr-canvas');
    const qrDataUrl = canvas ? canvas.toDataURL('image/png') : '';
    const u = currentUser;
    const win = window.open('', '_blank');
    win.document.write(`
      <!DOCTYPE html><html>
      <head><meta charset="UTF-8"><title>Card acces</title>
      <style>
        @media print { body { margin: 0; } }
        body { font-family: Arial, sans-serif; display: flex; justify-content: center; align-items: center; min-height: 100vh; background: #f4f4f4; }
        .card { background: #2C2C2A; border-radius: 16px; padding: 28px 24px; text-align: center; width: 280px; border: 3px solid #F5A623; }
        .logo { font-size: 15px; font-weight: 800; color: #fff; margin-bottom: 2px; }
        .logo span { color: #F5A623; }
        .sub { font-size: 10px; color: rgba(255,255,255,.4); margin-bottom: 18px; }
        .qr-wrap { background: white; border-radius: 10px; padding: 10px; display: inline-block; margin-bottom: 14px; }
        .name { font-size: 16px; font-weight: 800; color: #fff; margin-bottom: 4px; }
        .hint { font-size: 10px; color: rgba(255,255,255,.35); margin-top: 12px; line-height: 1.5; }
        .url { font-size: 9px; color: rgba(255,255,255,.2); margin-top: 8px; word-break: break-all; }
      </style></head>
      <body>
        <div class="card">
          <div class="logo">dosarmasina<span>.ro</span></div>
          <div class="sub">by Premium Support Iasi · 0733 898 999</div>
          <div class="qr-wrap"><img src="${qrDataUrl}" width="180" height="180"/></div>
          <div class="name">${u.first_name || ''} ${u.last_name || ''}</div>
          <div class="hint">Scaneaza pentru acces direct in dosarul masinii tale</div>
          <div class="url">${qrData.public_url}</div>
        </div>
        <script>window.onload = () => setTimeout(() => window.print(), 500);</script>
      </body></html>
    `);
    win.document.close();
  };

  if (loading) return <div style={{textAlign:'center',padding:'40px',color:'#888'}}>Se incarca...</div>;

  return (
    <div style={{maxWidth:'560px',margin:'0 auto'}}>
      <div style={{fontSize:'20px',fontWeight:800,marginBottom:'16px'}}>📱 QR & NFC</div>

      <div style={{display:'flex',gap:'8px',marginBottom:'16px'}}>
        {[
          { id:'qr', label:'📱 Codul QR' },
          { id:'nfc', label:'🏷️ Tag-urile NFC' },
        ].map(tab => (
          <button key={tab.id} onClick={()=>setActiveTab(tab.id)}
            style={{...s.btn,background:activeTab===tab.id?GOLD:'#F4F4F4',color:activeTab===tab.id?DARK:'#555',border:'0.5px solid #D3D1C7',padding:'8px 16px',fontSize:'12px'}}>
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === 'qr' && qrData && (
        <>
          <div style={{fontSize:'13px',color:'#888',marginBottom:'20px'}}>
            Scaneaza codul QR sau acceseaza link-ul pentru a intra direct in cont — fara parola.
          </div>
          <div style={{background:'#2C2C2A',borderRadius:'16px',padding:'32px',textAlign:'center',marginBottom:'14px',border:`3px solid ${GOLD}`}}>
            <div style={{fontSize:'15px',fontWeight:800,color:'#fff',marginBottom:'2px'}}>
              dosarmasina<span style={{color:GOLD}}>.ro</span>
            </div>
            <div style={{fontSize:'10px',color:'rgba(255,255,255,.4)',marginBottom:'20px'}}>by Premium Support Iasi</div>
            <div style={{background:'white',borderRadius:'12px',padding:'12px',display:'inline-block',marginBottom:'16px'}}>
              <QRCodeCanvas id="qr-canvas" value={qrData.public_url} size={200} bgColor="#FFFFFF" fgColor="#2C2C2A" level="M"/>
            </div>
            <div style={{fontSize:'18px',fontWeight:800,color:'#fff',marginBottom:'4px'}}>{currentUser.first_name} {currentUser.last_name}</div>
            <div style={{fontSize:'11px',color:'rgba(255,255,255,.35)',marginBottom:'8px'}}>{currentUser.email}</div>
            <div style={{fontSize:'10px',color:'rgba(255,255,255,.25)',wordBreak:'break-all',padding:'0 10px'}}>{qrData.public_url}</div>
          </div>
          <div style={{background:'#fff',border:'0.5px solid #D3D1C7',borderRadius:'12px',padding:'16px',marginBottom:'14px'}}>
            <div style={{fontSize:'12px',fontWeight:700,marginBottom:'8px'}}>🔗 Link direct de acces</div>
            <div style={{display:'flex',gap:'8px',alignItems:'center'}}>
              <div style={{background:'#F4F4F4',borderRadius:'8px',padding:'9px 12px',fontSize:'12px',fontFamily:'monospace',flex:1,wordBreak:'break-all',color:'#555'}}>{qrData.public_url}</div>
              <button onClick={copyLink} style={{...s.btn,background:copied?GREEN:GOLD,color:copied?'#fff':DARK,padding:'9px 16px',flexShrink:0}}>{copied ? '✓ Copiat!' : '📋 Copiaza'}</button>
            </div>
          </div>
          <div style={{background:'#E8EEF5',border:'0.5px solid #93C5FD',borderRadius:'12px',padding:'14px',marginBottom:'14px',fontSize:'12px',color:NAVY,lineHeight:1.7}}>
            <strong>🔒 Cum functioneaza:</strong><br/>
            • Oricine acceseaza acest link intra direct in contul tau<br/>
            • Ideal pentru card NFC sau autocolant QR pe masina<br/>
            • Fara parola necesara — acces instant
          </div>
          <div style={{display:'flex',gap:'10px'}}>
            <button onClick={printCard} style={{...s.btn,background:GOLD,color:DARK,flex:1}}>🖨 Tipareste card acces</button>
            <button onClick={downloadQR} style={{...s.btn,background:NAVY,color:'#fff',flex:1}}>⬇ Descarca QR</button>
          </div>
        </>
      )}

      {activeTab === 'nfc' && (
        <>
          <div style={{fontSize:'13px',color:'#888',marginBottom:'16px'}}>
            Tag-urile NFC asociate contului tău. Scanarea unui tag duce direct la destinația configurată.
          </div>
          <NFCSection user={currentUser}/>
        </>
      )}
    </div>
  );
}
